import 'twin.macro';
import React from 'react';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import ManualClassroomsProvider from '@teetsh/app/src/containers/App/context/ClassroomsContext/ManualClassroomsContext';
import { ROItemList } from '@teetsh/app/src/components/ROItemList';
import { EvaluationSearchResult } from '@teetsh/app/src/containers/Search/types';
import { BookOpenIcon as BookOpen } from '@heroicons/react/24/outline';
import Line from '@teetsh/app/src/containers/Search/components/Line';
import { CalendarIcon as Calendar } from '@heroicons/react/24/outline';
import isValid from '@teetsh/app/src/utils/time/isValid';
import { format } from '@teetsh/app/src/utils/time/format';

interface Props {
  evaluation: EvaluationSearchResult;
}

export function EvaluationPreview(props: Props) {
  const { evaluation } = props;
  const { locale, boLabels } = useUser();

  const isBoEmpty =
    evaluation?.referential?.matieres?.length === 0 &&
    evaluation?.referential?.domaines?.length === 0 &&
    evaluation?.referential?.competences?.length === 0 &&
    evaluation?.referential?.objectifs?.length === 0;
  return (
    <div tw="p-6">
      <ManualClassroomsProvider classrooms={[]}>
        <div>
          <div tw="flex items-center">
            <div tw="text-xl font-bold flex-grow">{evaluation.name}</div>
            {evaluation.carnetName}
          </div>
        </div>
        <div tw="border-b w-full my-4" />

        <div tw="grid grid-cols-12 gap-x-2 gap-y-4 mb-8">
          {isValid(evaluation.date) && (
            <Line icon={Calendar}>
              {format(evaluation.date, locale, 'eeee dd MMMM yyyy à hh:mm')}
            </Line>
          )}
          {!isBoEmpty && (
            <Line icon={BookOpen}>
              <div tw="space-y-1">
                <ROItemList
                  label={boLabels.matiereSingularName}
                  labelPlural={boLabels.matierePluralName}
                  items={(evaluation?.referential?.matieres || []).map(
                    m => m.value,
                  )}
                />
                <ROItemList
                  label={boLabels.domaineSingularName}
                  labelPlural={boLabels.domainePluralName}
                  items={(evaluation?.referential?.domaines || []).map(
                    m => m.value,
                  )}
                />
                <ROItemList
                  label={boLabels.competenceSingularName}
                  labelPlural={boLabels.competencePluralName}
                  items={(evaluation?.referential?.competences || []).map(
                    m => m.value,
                  )}
                />
                <ROItemList
                  label={boLabels.objectifSingularName}
                  labelPlural={boLabels.objectifPluralName}
                  items={(evaluation?.referential?.objectifs || []).map(
                    m => m.value,
                  )}
                />
              </div>
            </Line>
          )}
        </div>
      </ManualClassroomsProvider>
    </div>
  );
}
